// Module
var code = "<div ng-if=$ctrl.venue><iframe iframe-url=$ctrl.venue.data.virtualTourUrl frameborder=0 style=border:0></iframe></div>";
// Exports
module.exports = code;